import React, { Component } from 'react';

class getMenu extends Component {
  render (){
    return (
       <div className="grid-container_menu">
        <div className="div_guardar_b"><button className="btn_menu"onClick={ () => this.props.getActualizarCabecera()}>Guardar</button></div>
        <div className="div_cerrar_b"><button className="btn_menu"onClick={ () => this.props.getActualizarCabeceraPax()}>Pax</button></div>
        <div className="div_preferencia"><button className="btn_menu"onClick={ () => this.props.getPreferenciaItem()}>Preferencias</button></div>
        <div className="div_salir_cuenta"><button className="btn_menu" onClick={ () => this.props.Abtn_encerar_cuenta()}>No Guardar</button></div>
        <div className="div_precuenta"><button className="btn_menu" onClick={ () => this.props.getPrecuentaAPI()}>Precuenta</button></div>
        <div className="div_funciones"><button className="btn_menu">Funciones</button></div>
      </div>
    )
  }
}
export default getMenu;
/*  <div className="div_cerrar_b"><button className="btn_menu"onClick={ () => this.props.getCerrarCabecera()}>Cerrar</button></div>*/
